import { Title, Texts, Media } from "../Object";
import { Space } from "../Layout";
import { Scroll } from "../Animation";

const Flow = () => {
  return (
    <>
      <div className="l-row">
        <Title slug="flow" type="border" />
        <Space size={["64px 0 0", "48px 0 0"]}>
          <Scroll>
            <Media src="common/flow" alt="flow" sp="sp" class="p-img__flow"></Media>
          </Scroll>
        </Space>
      </div>
    </>
  );
};

export default Flow;